import logo from "../assets/LogoSVG.png";
import logo1 from "../assets/table-img.svg";
import logo2 from "../assets/table-img2.svg";
import {
  faFileInvoiceDollar,
  faCog,
  faCalendarAlt,
  faEnvelope,
  faUsers,
  faVolleyballBall,
  faPhoneAlt,
  faFileExport
} from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import TableActionMenu from "./TableActionMenu/TableActionMenu";
import checkIcon from "../assets/check-icon.svg";
import { Fragment } from "react";
import CustomSelect from "./CustomSelect/CustomSelect";
import axiosApi from "../core/interceptor/interceptor";
import { config } from "../config";
import { Link } from "react-router-dom";
import trashIcon from "../assets/trash-icon.svg";
import closeIcon from "../assets/close-icon1.svg";

export const PaymentType = {
  CHEQUE_CASH: 'cheque',
  CARD: 'card',
}

export const PaymentTypeLabel = {
  cheque: 'Check',
  card: 'Card',
}
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function maskingToPlainNumber(number) {
  if (!number) {
    return '';
  }
  number = (number).toString().replace(/[- )(]/g, '');
  return number;
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + (phoneNumberString || '').toString()).replace(/[- )(\D]/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return 'N/A';
}

export function LazyLoader() {
  return (
    <div className="loading-wrapper">
      <img src={logo} alt="logo" />
      <span>Loading...</span>
    </div>
  );
}
export function capitaLizeString(str) {
  var i, frags = str.split('_');
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}
export function stripHtml(html) {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function loadColumns({ columns = [] }, actionChange = null) {
  const helperSelectorFunc = (row, selector) => {
    if (selector.length) {
      return row[selector[0]] ? helperSelectorFunc(row[selector.splice(0, 1)], selector) : null;
    }
    return row;
  }
  let isTeamList = false;
  return columns.map((column, index) => (
    column && column?.isTeamList ? isTeamList = true : '',
    {
      name: (function () {
        return (
          <div className="table-header"
            style={{
              padding: '8px 10px',
              textAlign: 'left',
              wordBreak: 'break-word'
            }}>
            {column.name}
          </div>
        )
      }()),
      selector: () => column.selector,
      sortable: column.sortable !== undefined ? column.sortable : true,
      className: 'left-align',
      style: {
        padding: '0'
      },
      cell: row => (<div
        className="inner-cell"
        data-tag="allowRowEvents"
        style={
          function () {
            const style = {
              width: '100%',
              padding: '8px 10px',
              minHeight: '32px',
              display: 'inline-flex',
              alignItems: 'center',
              height: '100%',
              fontSize: '13px',
              fontWeight: '500',
              lineHeight: '18px',
              color: 'var(--blk)',
              fontFamily: 'Mulish, sans-serif',
              textAlign: 'left',
              background: isTeamList && row && (row.paid_by === 'cheque' || row.registered_by === 'admin') ? 'var(--yellow)' : ''
            }
            return column.style && typeof column.style === 'object' ? { ...style, ...column.style } : { ...style };
          }(column)
        }>
        {
          (function () {
            if (column.selector) {
              if (column.type === 'table_action') {
                if (column.mode === 'menu') {
                  const menu = column.options.filter(x => x.actionFnc = function (data) {
                    actionChange({
                      action: x.action,
                      data
                    })
                  })
                  return <Fragment key={`unique-table-action-${index}`}><TableActionMenu keyRandom={`unique-table-action-${index}`} menuItem={menu} data={row} /></Fragment>
                } else if (column.mode === 'action') {
                  return <>
                    <button title='Delete' className="btn with-icon" onClick={() => column?.actionHandler(row)}><img src={trashIcon} alt="" /></button>
                  </>
                } else if (column.mode === 'cancel') {
                  return <>
                    {new Date(row?.schedule_date_time_tz) > new Date() && row?.status === 'scheduled' && <button title='Cancel' className="btn with-icon" onClick={() => column?.actionHandler(row)}><img src={closeIcon} alt="" /></button>}
                  </>
                } else {
                  return row?.payment_status === 'paid'
                    ? <Fragment key={`unique-table-action-${index}`}>
                      {
                        (() => {
                          if (row.paid_by !== PaymentType.CHEQUE_CASH) {
                            if (!row?.is_refunded) {
                              if (Number(row.for_feit_fees) > 0) {
                                return row.payment_from === 'paypal'
                                  ? 'Refund Through Paypal'
                                  : <button className="refund-forfeit-button" type='submit' onClick={() => column?.actionHandler(row)}>Refund Forfeit</button>;
                              }
                              return 'No Foreit';
                            }
                            return 'Refunded';
                          }
                        })()
                      }
                    </Fragment>
                    : ''
                }
              }
              if (column.type === 'templates_action') {
                const action = <><button className="btn" onClick={() => column?.actionHandler(row?.id)} type='button'>Edit</button></>;
                return action;
              }
              if (column.type === 'status') {
                if (column.dropdown) {
                  const changeStatus = (status) => {
                    axiosApi.patch(`${config.apiUrl}/leagues/change-status/${row.id}`, {
                      status,
                    }).then(() => {
                      row[column.selector] = status;
                    }).catch((err) => {
                      console.error(err);
                    });
                  }
                  return (
                    <Fragment key={`unique-table-drop-${index}`}>
                      <div className="input-wrapper">
                        <CustomSelect
                          uniqueKey={`custom-select-drop-${index}`}
                          data={Array.isArray(column.options) ? column.options : []}
                          placeholder={row[column.selector] ? LEAGUE_STATUS[row[column.selector]] : 'Select Status'}
                          type={'status'}
                          noScroll={true}
                          onSelect={(ele) => ele && changeStatus(ele.id)}
                          selector="title"
                          shoWarning={!!column.showWarning}
                        />
                      </div>
                    </Fragment>
                  );
                } else {
                  if (row?.Champion) {
                    return LEAGUE_STATUS[row?.Champion?.status];
                  }
                  return LEAGUE_STATUS[row[column.selector]];
                }
              }
              if (column.type === 'template_type') {
                return TEMPLATE_TYPE[row[column.selector]];
              }
              if (column.type === 'time') {
                return moment(row[column.selector]).format('h:mm A');
              }
              if (column.type === 'date') {
                return moment(row[column.selector]).format('M/DD/YYYY');
              }
              if (column.type === 'datetime') {
                return moment(row[column.selector]).format('M/DD/YYYY h:mm A');
              }
              if (column.type === 'contact_number') {
                return row[column.selector] ? formatPhoneNumber(row[column.selector]) : 'N/A';
              }
              if (column.type === 'additional_request') {
                return <span className="ellip-on-3" title={row[column.selector] ? row[column.selector] : ''}>{row[column.selector] ? row[column.selector] : 'N/A'}</span>;
              }
              if (column.type === 'checked-i') {
                return row[column.selector] ? <img className="icon" src={checkIcon} alt="" /> : '';
              }
              if (column.type === 'registered_through') {
                return ((col, rw) => {
                  return (
                    <>
                      {rw[col.selector]}
                      {rw['registered_through'] === 'C' ? <img src={logo1} alt="" /> : <img className="icon" src={logo2} alt="" />}
                    </>
                  )
                })(column, row);
              }
              if (column.type === 'hosted_by') {
                return ((col, rw) => {
                  return (
                    <>
                      {rw[col.selector]}
                      {rw['hosted_by'] === 'cleveland' ? <img src={logo1} alt="" /> : <img className="icon" src={logo2} alt="" />}
                    </>
                  )
                })(column, row);
              }
              if (column.type === 'count') {
                return row[column.selector].split(',').length;
              }
              if (column.selector === 'playersCount') {
                return row['players']?.[0]?.players;
              }
              if (column.type === 'winLoss') {
                return row['number_wins'] + ' / ' + row['number_losses'];
              }
              if (column.type === 'fullName') {
                return (row['user'] && row['user']['first_name'] && row['user']['last_name']) ? (row['user']['first_name'] + ' ' + (row['user']['middle_name'] ? row['user']['middle_name'] + ' ' : '') + row['user']['last_name']) : 'N/A';
              }
              const sel = column.selector.split('.');
              if (column.type === 'list') {
                return column.renderer(helperSelectorFunc(row, sel));
              }
              if (column.type === 'awarded') {
                return helperSelectorFunc(row, sel) ? <img className="icon" src={checkIcon} alt="" /> : '';
              }
              if (column.type === 'clickable_transaction_id') {
                return <Link to={{
                  pathname: '/admin/transactions/individual',
                  state: {
                    search_string: row?.transaction_id,
                  }
                }}>{helperSelectorFunc(row, sel)}</Link>
              }
              if (column.type === 'select' || column.type === 'select-individual') {
                return <div className="inner-blk-reset-password" key={`unique-table-checkbox-${row.id ? row.id : index}`}>
                  <label className="checkbox">
                    <input type="checkbox" disabled={!column?.leagueSelected?.id && column.type === 'select-individual' && row?.league?.status && !['active', 'sign_up', 'need_schedule'].includes(row?.league?.status)} name="send_email" checked={row[column.selector]} onChange={(e) => column.actionHandler(row.id, e.target.checked, row)} />
                    <span className={`checkmark ${!column?.leagueSelected?.id && column.type === 'select-individual' && row?.league?.status && !['active', 'sign_up', 'need_schedule'].includes(row?.league?.status) ? 'disabled' : ''}`} ></span>
                  </label>
                </div>
              }
              if (column.type === 'conditional-select') {
                return <div className="inner-blk-reset-password" key={`unique-table-checkbox-${row.id ? row.id : index}`}>
                  {new Date(row?.schedule_date_time_tz) > new Date() && row?.status === 'scheduled' && <label className="checkbox">
                    <input type="checkbox" disabled={!column?.leagueSelected?.id && column.type === 'select-individual' && row?.league?.status && !['active', 'sign_up', 'need_schedule'].includes(row?.league?.status)} name="send_email" checked={row[column.selector]} onChange={(e) => column.actionHandler(row.id, e.target.checked, row)} />
                    <span className={`checkmark ${!column?.leagueSelected?.id && column.type === 'select-individual' && row?.league?.status && !['active', 'sign_up', 'need_schedule'].includes(row?.league?.status) ? 'disabled' : ''}`} ></span>
                  </label>}
                </div>
              }
              if (column.type === 'transaction_from') {
                return (
                  <>
                    <Link className="clickable-row-league" to={{
                      pathname: '/admin/leagues/teams',
                      search: `?leagueId=${row?.league?.id}`,
                      state: {
                        from: 'transactions',
                      }
                    }}>{helperSelectorFunc(row, sel)}
                      {row?.league?.hosted_by === 'cleveland' ? <img src={logo1} alt="" /> : <img className="icon" src={logo2} alt="" />}</Link>
                  </>
                );
              }
              if (column.type === 'individual_reg_old') {
                return row.season ? row.season?.name : row?.league?.season?.name ? row?.league?.season?.name : '';
              }
              if (column.type === 'for_feit_fees') {
                return row.for_feit_fees ? `$${row.for_feit_fees}` : row.for_feit_fees;
              }
              if (column.type === 'paid_by_type') {
                if (row.paid_by === 'cheque') {
                  return 'Check';
                }
                return row.paid_by ? row.paid_by.charAt(0).toUpperCase() + row.paid_by.slice(1) : 'N/A';
              }
              if (column.type === 'registered_by') {
                return row.registered_by ? row.registered_by.charAt(0).toUpperCase() + row.registered_by.slice(1) : 'N/A';
              }
              if (column.type === 'paid_amount_type') {
                if (row.registration_fees) {
                  if (row.payment_status === 'paid') {
                    if (+row.registration_fees + +row?.for_feit_fees + +row?.stripe_fees === +row.total_fees) {
                      return <div>Complete ({formatNumberToCurrency(row.total_fees)})</div>
                    } else {
                      return <div className="amount-status-team">
                        <span>{+row?.total_fees ? `Paid(${formatNumberToCurrency(row.total_fees)})` : ''}</span>
                        <span>Remaining ({formatNumberToCurrency(+row.registration_fees + +row?.for_feit_fees - +row.total_fees)})</span>
                      </div>
                    }
                  } else {
                    return <div>Unpaid ({formatNumberToCurrency(row.total_fees)})</div>
                  }

                } else {
                  return '';
                }
              }
              if (column.type === 'refund_applicable') {
                return row.refund_applicable ? `${formatNumberToCurrency(row.refund_applicable)}` : '$0.00';
              }
              if (column.type === 'refunded') {
                return row.refunded ? `${formatNumberToCurrency(row.refunded)}` : '$0.00';
              }
              if (column.type === 'player_type') {
                if (row?.OwnerTeam?.id) {
                  return 'Registered as Team Owner';
                } else if (row.individual_registration) {
                  return 'Registered as Individual';
                } else {
                  return 'Added by Admin';
                }
              }
              if (column.type === 'player_payment_status') {
                if (row?.individual_registration?.id) {
                  if (row.individual_registration.payment_status === 'paid') {
                    return 'Paid';
                  } else if (row.individual_registration.payment_status === 'unpaid') {
                    return 'Unpaid';
                  }
                }
                return '';
              }
              if (column.type === 'player_payment_type') {
                if (row?.individual_registration?.id) {
                  if (row.individual_registration.paid_by === 'card') {
                    return 'Card';
                  } else if (row.individual_registration.paid_by === 'cheque') {
                    return <div className="mark-check">Check {row.individual_registration.payment_status === 'unpaid' && <button onClick={() => column.markPaid(row?.individual_registration?.id)} className="mark-paid-btn">Paid</button>}</div>;
                  }
                }
                return '';
              }

              if (column.type === 'payment-status-individual') {
                if (row.payment_status) {
                  return row.payment_status.charAt(0).toUpperCase() + row?.payment_status?.slice(1);
                } else {
                  return ''
                }
              }

              if (column.type === 'ind-action') {
                return column.renderer(row);
              }

              return helperSelectorFunc(row, sel) || (column.type === 'count' ? 0 : 'N/A');
            }
          })()
        }
        {/* <img src={logo1} alt="icon" /><img className="icon" src={logo2} alt="icon" /> */}
      </div >)
    }
  )
  );
}

/*** 
 * ***********************
 * **** Don't Remove *****
 * ***********************
 **/

// export function rowClickedAction(row_type) {
//     const action = {
//         user_module: function (data) {
//             console.log('This ------>', this);
//             // this.setOpen(o => !o)
//             this.setSelectUser(data);
//             if (this.props.type === 'user') {
//                 this.setModalContent(this.ModalContentUser({ data }));
//             } else if (this.props.type === 'admin') {
//                 this.setModalContent(
//                     this.ModalContentAdmin({
//                         type: 'admin',
//                         userData: data,
//                     })
//                 )
//             } else {
//                 // this.setModalContent(<ModalContentEmployee type={'employee'} closeModal={closeModal} userData={data} />)
//             }
//         }
//     }
//     return action[row_type];
// }
export function getUrlToPush(type, params = null) {
  const url = {
    league_overview: '/admin/leagues',
    league_groups: '/admin/leagues/teams',
    league_groups_teams: '/admin/leagues/groups/teams',
    league_champions_team: '/admin/leagues/champions/team',
    league_team_info: '/admin/leagues/LeagueGroups/TeamInfo',
    league_group_status: '/admin/leagues/need-schedule',
    create_schedule: '/admin/leagues/schedule',
    transactions: '/admin/transactions',
  }

  return `${url[type]}${params ? `/${params}` : ''}`;
}

export const sideMenuItems = [
  // {
  //   route: 'menu',
  //   slug: 'menu',
  //   text: 'Menu',
  //   icon: faUtensils
  // },
  // {
  // 	route: 'sales',
  // 	slug: 'sales',
  // 	text: 'Sales',
  // 	icon: faFileInvoiceDollar
  // },
  // {
  //   route: 'coupons',
  //   slug: 'coupons',
  //   text: 'Coupons',
  //   icon: faPercent
  // },
  {
    route: 'email',
    slug: 'email',
    text: 'Email',
    icon: faEnvelope
  },
  {
    route: 'users',
    slug: 'users',
    text: 'Users',
    icon: faUsers
  },
  {
    route: 'event-page',
    slug: 'event-page',
    text: 'Events',
    icon: faCalendarAlt,
    childs: [
      { url: 'leads', text: 'Leads', type: 'event-page', acl: 'leads' },
      { url: '', text: 'Events', type: 'event-page', acl: 'events' },
      { url: 'documents', text: 'Documents', type: 'event-page', acl: 'documents' },
      { url: 'all-invoices', text: 'Invoices', type: 'event-page', acl: 'invoices' },
      { url: 'public-events', text: 'Scan Tickets', type: 'event-page', acl: 'scan-ticket' },
      { url: 'website-content', text: 'Web Content', type: 'event-page', acl: 'web-content' },
    ],
  },
  {
    route: 'leagues',
    slug: 'leagues',
    text: 'Leagues',
    icon: faVolleyballBall,
    childs: [
      { url: '', text: 'Overview' },
      { url: 'master-schedule', text: 'Master Schedule' },
      { url: 'sports', text: 'Sports' },
      { url: 'classifieds', text: 'Classifieds' },
      { url: 'individual-registrations', text: 'Individual Registration' },
      { url: '', text: 'Add/Modify Locations', type: 'location' },
      { url: 'level-of-play', text: 'Level of Play' },
    ]
  },
  {
    route: 'transactions',
    slug: 'transactions',
    text: 'Transactions',
    icon: faFileInvoiceDollar,
  },
  {
    route: 'contact-us',
    slug: 'contact_us',
    text: 'Contact Us',
    icon: faPhoneAlt,
    // visible: true
  },
  {
    route: 'sms-logs/league-reminders',
    slug: 'sms_logs',
    text: 'SMS Logs',
    icon: faFileExport,
    // visible: true
  },
  {
    route: 'settings',
    slug: 'settings',
    text: 'Tools & Settings',
    icon: faCog,
    childs: [
      { url: 'disclaimer', text: 'Disclaimers' },
      { url: 'policy', text: 'Policies' },
      { url: 'headline', text: 'Headlines' },
      { url: 'templates', text: 'SMS Templates' },
      { url: 'notification-banner', text: 'Notification Banner' },
      { url: 'sport-notification', text: 'Sports Notification' },
      { url: 'sponsors', text: 'Sponsors' },
      { url: 'advertisements', text: 'Advertisements' },
      // { url: 'order', text: 'Orders' },
    ]
  },
  {
    route: '',
    slug: 'messages',
    text: 'Bulk Message',
    icon: faEnvelope,
    childs: [
      { url: 'send-email?hideBtn=1', text: 'Email', type: 'bulk-messages', acl: 'mass_email' },
      { url: 'send-sms?hideBtn=1', text: 'SMS', type: 'bulk-messages', acl: 'mass_text' },
    ]
  },

];

export const TOAST_NOTIFICATION = {
  error: {
    className: 'errorToastNotification',
    bodyClassName: 'errorToastBody',
    progressClassName: 'errorToastProgressBar'
  },
  success: {
    className: 'success-toast',
    bodyClassName: 'errorToastBody',
    progressClassName: 'errorToastProgressBar'
  }
}

/**
 * Converts local date to utc.
 * Only valid for Date Object.
*/
export const convertToUTC = (dateObj) => {
  if (dateObj instanceof Date) {
    return moment(dateObj).utc();
  }
  throw Error('Argument expected [Date][Object].');
}

export const GENDER = {
  M: 'Male',
  F: 'Female',
  C: 'Co-ed'
}

export const GENDER_MESSAGE = [
  {
    title: 'Both',
    value: ''
  },
  {
    title: 'Male',
    value: 'M',
  },
  {
    title: 'Female',
    value: 'F',
  },
];

export const COLORS = ['#a000a0', '#0000a0', '#a0a0a0', '#00a0a0', '#a0a000', '#00a000', '#c1dbe8', '#e8c761', '#077e8a', '#306960', '#92d811', '#e6e334', '#e69934', '#e67834', '#dc3672', '#bf99a7', '#68676d', '#a2bbbb', '#c97575', '#d1cfd0', '#949494', '#d69090', '#8c7272', '#b4cfcb', '#9e880b', '#d126c3', '#6e5e6c', '#707070', '#e3ce59', '#3d3922', '#96f095', '#19d4e6', '#a093a3', '#70404c', '#a000a0', '#0000a0', '#a0a0a0', '#00a0a0', '#a0a000', '#00a000', '#c1dbe8', '#e8c761', '#077e8a', '#306960', '#92d811', '#e6e334', '#e69934', '#e67834', '#dc3672', '#bf99a7', '#68676d', '#a2bbbb', '#c97575', '#d1cfd0', '#949494', '#d69090', '#8c7272', '#b4cfcb', '#9e880b', '#d126c3', '#6e5e6c', '#707070', '#e3ce59', '#3d3922',];

export const LEAGUE_STATUS = {
  active: 'Active',
  complete: 'Complete',
  cancel: 'Cancel',
  sign_up: 'Sign-up',
  pending: 'Pending',
  archive: 'Archive',
  early: 'Early Games',
  late: 'Late Games',
  balanced: 'Balanced',
  need_schedule: 'Needs Schedule',
  unpaid: 'Unpaid',
  paid: 'Paid',
  failed: 'Failed',
  roster_incomplete: 'Roster Incomplete',
  waiting: 'Waiting',
  refunded: 'Refunded'
}


export const MESSAGE_STATUS = {
  scheduled: 'Scheduled',
  processing: 'Processing',
  processed: 'Processed',
  sent: 'Sent',
  delivery_unknown: 'Delivery Unknown',
  delivered: 'Delivered',
  undelivered: 'Undelivered',
  failed: 'Failed',
  received: 'Received',
  disabled: 'Disabled'
}

export const TEMPLATE_TYPE = {
  regular_reminder_template: 'Regular Reminder',
  regular_reschedule_message_template: 'Regular Reschedule',
  regular_cancel_message_template: 'Regular Cancellation',
  playoff_reminder_template: 'Playoff Reminder',
  playoff_reschedule_message_template: 'Playoff Reschedule',
  playoff_cancel_message_template: 'Playoff Cancellation',
}

export const PREFERRED_TIME = {
  early: 'Early Games',
  late: 'Late Games',
  balanced: 'Balanced',
}

export const PAYMENT_STATUS = {
  paid: 'Paid',
  unpaid: 'Unpaid',
  failed: 'Failed',
  refunded: 'Refunded',
  'refund-failed': 'Refund Failed',
}

export const PAYMENT_MODE = {
  cash: 'Cash',
  card: 'Card',
  cheque: 'Cheque',
}

export const TEAM_STATUS = {
  active: 'Active',
  unpaid: 'Unpaid',
  roster_incomplete: 'Roster Incomplete',
  archive: 'Archive',
  waiting: 'Waiting',
}

export const ShirtSize = {
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large',
  XXL: 'Largest',
}

export const HOSTED_BY = {
  mulberry: 'Mulberry',
  cleveland: 'Cleveland',
  both: 'Both'
}

export const phoneNumberMask = '###-###-####';
export const TEXT_MESSAGE_LENGTH = 160;
export const BACK_DROP_FALSE = false;
export const TEMPLATE_TEXT_LENGTH = 1000;

export const teamsPreferredTime = {
  preferred_time: [
    {
      id: 'early',
      title: 'Early Games',
    },
    {
      id: 'late',
      title: 'Late Games',
    },
    {
      id: 'balanced',
      title: 'Balanced',
    },

  ],
}

export function validateRequiredFields(fieldsObject) {
  const keys = Object.keys(fieldsObject);
  return !!keys.length && keys.some(key => !(fieldsObject[key] || '').toString().trim());
}

export function generateDropList(_ = {}) {
  const list = Object.keys(_).map(key => ({ id: key, title: _[key] }));
  return list;
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const days_played = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const RECURRING_TYPE = {
  never: 'Never',
  weekly: 'Weekly',
  bi_weekly: 'Bi-weekly',
  monthly: 'Monthly',
  yearly: 'Yearly'
}

export const YES_NOT_TYPE = [
  {
    title: 'Yes',
    value: 1,
  },
  {
    title: 'No',
    value: 0
  }
];

export const YES_NOT_LABEL = {
  true: 'Yes',
  false: 'No'
}

export const REMINDER_TYPE = {
  day: 'Day Before',
  hour: 'Hour Before'
}


export const PLAYER_TYPE = {
  all: 'All Players',
  captain: 'Captains'
}

export const PRICE_TYPE = {
  person: 'Person',
  group: 'Group'
}
export const TEMPLATE_STATUS = {
  reminder: 'Reminder',
  follow_up: 'Follow Up'
}
export const Disclaimer_Type = {
  signUp_disclaimer: 'Sign-up Disclaimer',
  covid_policy: 'Covid Policy',
  team_reg_policy: 'Team Registration Policy',
  site_headline: 'Site Headline',
  league_headline: 'League Headline',
  notification_banner: 'Notification Banner',
}

export const Website_Content = [
  {
    id: 1,
    name: 'Home Slider',
    data: []
  },
  {
    id: 2,
    name: 'Venues',
    data: []
  },
  {
    id: 4,
    name: 'Background',
    data: []
  },
  {
    id: 3,
    name: 'Inclusions',
    data: []
  }
]

export const EVENT_TYPE = {
  HOME_SLIDER: 'home-slider',
  VENUE: 'venue',
  INCLUSION: 'inclusions',
  BACKGROUND: 'background'
}
export const TBD = {
  name: 'TBD',
  value: [null, undefined, 'Invalid date', 'Invalid Date', 'invalid date'],
}
export const EVENT_STATUS = {
  public: 'Public',
  private: 'Private'
}
export const EVENT_OCCASION = [
  { id: 1, name: 'Concert' },
  { id: 2, name: 'Conference' },
  { id: 3, name: 'Dinner' },
  { id: 4, name: 'Festival' },
  { id: 5, name: 'Meeting' },
  { id: 6, name: 'Party' },
  { id: 7, name: 'Retreat' },
  { id: 8, name: 'Wedding' },
  { id: 9, name: 'Other' }
]
export function formatNumberToCurrency(num) {
  if (!num) {
    return;
  }
  const result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(num);
  return result;
}
export const LEAD_STATUS = {
  open: 'Open',
  rejected: 'Rejected',
  in_progress: 'In Progress',
  approved: 'Approved',
  active: 'Active',
  complete: 'Complete',
  delete: 'Delete',
  waiting: 'Waiting',
  cancel: 'Cancel',
}
export const PAID_TYPE = {
  free: 'Free',
  paid: 'Paid'
}

export const getStripeAmount = (fee) => {
  return +(((+fee + 0.30) / (1 - 0.029)).toFixed(2));
};

export const RegisteredBy = {
  user: 'User',
  admin: 'Admin',
}

export const REFUNDED_STATUS = {
  0: 'Not Refunded',
  1: 'Refunded',
}

export const WARNING_DIALOG_TYPE = {
  ADD_PLAYER: 'add-player'
}

export const SCHEDULE_TYPE = {
  fixed: 'Fixed Time',
  variable: 'Relative hour(s)'
}

export const SETTING_TYPE = ['regular_reminder_template', 'playoff_reminder_template'];
export const TAGS = [
  { tag: '{first_name}', label: 'First Name' },
  { tag: '{last_name}', label: 'Last Name' },
  { tag: '{season_name}', label: 'Season Name' },
  { tag: '{league_name}', label: 'League Name' },
  { tag: '{location}', label: 'Location' },
  { tag: '{court}', label: 'Court' },
  { tag: '{date}', label: 'Date' },
  { tag: '{time}', label: 'Time' },
  { tag: '{my_team_name}', label: 'My Team Name' },
  { tag: '{opponent_team_name}', label: 'Opponent Team Name' },
  { tag: '{old_date}', label: 'Old Date' },
  { tag: '{old_time}', label: 'Old Time' },
];

export const OLD_TAGS = ['Old Date', 'Old Time'];

export const stripHTMLToPlainText = (input) => {
  if (!input) {
    return "";
  }
  const withoutScripts = input.replace(
    /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
    "",
  );
  const withLineBreaks = withoutScripts.replace(/<br\s*\/?>/gi, "\n");

  const div = document.createElement("div");
  div.innerHTML = withLineBreaks;
  const text = div.textContent || div.innerText || "";

  return text.replace(/\r\n/g, "\n").trim();
}